import React, { useState } from 'react';
import { connect } from 'react-redux';
import BaseModal from 'components/Modal';
import { showSelector } from 'containers/PageHeader/FavoritesModal/selectors';
import { setShow } from 'containers/PageHeader/FavoritesModal/actions';
import Input from 'components/Inputs/Input';
import './styles.scss';
import ModalButton from 'components/Modal/Button';
import { Mutation } from '@apollo/client/react/components';
import { POST_FAVORITE } from 'apollo/queries';
import { CONTEXT, GlobalFilterType } from 'utils/types';
import { favGroupsClient } from 'apollo';
import { clientIdSelector } from 'store/global/selectors';

interface Props {
  show: boolean;
  onClose: any;
  globalFilter: GlobalFilterType;
  clientId: string;
}

const FavoritesModal: React.FC<Props> = ({ show, onClose, globalFilter, clientId }) => {
  const [name, setName] = useState('');

  const saveFavorite = (postFavorite, onClose) => {
    postFavorite({
      variables: {
        clientID: clientId,
        input: {
          context: CONTEXT,
          name: name,
          data: globalFilter,
          url: window.location.href
        }
      }
    });
    onClose();
  };

  return (
    <div className="">
      <Mutation mutation={POST_FAVORITE} client={favGroupsClient as any}>
        {postFavorite => {
          return (
            <BaseModal
              baseClassName="favorites-modal"
              buttons={[
                <ModalButton primary={false} onClick={onClose}>
                  Cancel
                </ModalButton>,
                <ModalButton
                  disabled={name === ''}
                  onClick={() => saveFavorite(postFavorite, onClose)}
                >
                  Save
                </ModalButton>
              ]}
              show={show}
              title="Save page to favorites"
              onClose={onClose}
            >
              <div className="favorites-modal-body">
                <Input
                  isValid={name !== ''}
                  placeholder="Name this page"
                  value={name}
                  onChange={value => setName(value)}
                />
              </div>
            </BaseModal>
          );
        }}
      </Mutation>
    </div>
  );
};

const mapStateToProps = state => ({
  show: showSelector(state),
  clientId: clientIdSelector(state)
});

const mapDispatchToProps = dispatch => ({
  onClose: () => {
    dispatch(setShow(false));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(FavoritesModal);
